import React, { useState, useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import styled from 'styled-components';
import Boton from '../eventos/navegacion_y_accion/Boton';
import Titulo from "../basicos/Titulo";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import { fetchEditarCategoria,fetchObtenerCategoria } from '../../../peticiones_API/PeticionesCategoriaConvocatoria';
import ErrorForm from '../eventos/avisos/Alerta';
import { useParams } from "react-router-dom";
import { handleChangeErrors, handleSubmitErrors, todosDatosCorrectos } from '../../validacion/ValidationFormCategoria';
import { DatosCorrectos, CategoriaExistente, DatosIncorrectos } from '../eventos/avisos/VentanaEmergente';
import { ToastContainer, toast } from "react-toastify";

const FormEditarCategoria = ({ subcategorias }) => {

    const { Id } = useParams();
    console.log("Id ",Id);
    const [formData, setFormData] = useState({
        IdCategoria:'',
        categoria: '',
        descripcion: '',
        urlCat: '',
        subcategorias: [],
        subcategoria: false,
        nivel: false,
        anexo: false
    });

    const camposRequeridos = {
        categoria: "Debes insertar un nombre",
    };

    const [estadoCampoReque, setEstadoCampoReque] = useState({
        categoria: null,
    });

    let [formCompletado, setFormCompletado] = useState(null);
    const [estadosActualizados, setEstadosActualizados] = useState(false);

    const [errorEnviarForm, setErrorEnviarForm] = useState({
        categoriaDuplicada: null,
        refDuplicado: null

    });

    const [botonRenderClick, setBotonRenderClick] = useState(false);

    const handleChangeMultiple = (event) => {
        setFormCompletado(null); // Reiniciar el estado de formCompletado al cambiar cualquier campo
        const { options } = event.target;
        const value = [];
        for (let i = 0, l = options.length; i < l; i += 1) {
            if (options[i].selected) {

                value.push(options[i].value);
            }
        }
        setFormData(prevFormData => ({
            ...prevFormData,
            subcategorias: value
        }));
    };
    
    const handleSubmit = async (event) => {
        event.preventDefault();

        if(event.target.name === "guardar_cambios_statico"){
            setBotonRenderClick(false);
        }else{         
            setBotonRenderClick(true);
        }

        setEstadosActualizados(false);

        handleSubmitErrors(formData, estadoCampoReque, setEstadoCampoReque, camposRequeridos, setEstadosActualizados);
    };


    useEffect(() => {
        async function fechtPrincipal() {
            try {

                const categoria = await fetchObtenerCategoria(Id);


                console.log("listado", categoria);

                const subcategoriasIds = categoria.SubCategoria ? categoria.SubCategoria.map(sub => sub.Id) : [];

                setFormData(prevFormData => ({
                    ...prevFormData,
                    IdCategoria: categoria.Id,
                    categoria: categoria.categoria,
                    descripcion: categoria.descripcion,
                    urlCat: categoria.urlCat,
                    urlCatViejo: categoria.urlCat,
                    subcategorias: subcategoriasIds,
                    subcategoria:categoria.subcategoria,
                    nivel:categoria.nivel,
                    anexo:categoria.anexo
                }));

                const campos = [
                    'categoria', 'urlCat'
                ];

                campos.forEach(campo => {

                    if (categoria[campo] != null) {
                        setEstadoCampoReque(prevState => ({
                            ...prevState,
                            [campo]: false
                        }));
                    }
                });


            } catch (error) {
                console.log("Ha habido un error:", error);
            }
        }

        fechtPrincipal();
    }, []);

    useEffect(() => {

        if (estadosActualizados) {
            console.log("formData", formData);
            console.log("estadoCampoReque", estadoCampoReque);

            let validacionTodosDatos = todosDatosCorrectos(formData, estadoCampoReque);
            let todosCamposFalse = validacionTodosDatos.todosCamposFalse();
            (async () => {
                if (todosCamposFalse === true) {
                    setFormCompletado(true);
                    console.log("Simulacion editar categoria");

                    try {

                        const response = await fetchEditarCategoria(formData);

                    } catch (error) {

                        setFormCompletado(false);

                        if (error?.response?.data?.error === 'categoria existe') {

                            setErrorEnviarForm(prevFormData => ({ ...prevFormData, categoriaDuplicada: true }));
                        }
                    }
                } else {
                    toast.error("Faltan campos por rellenar")
                }
            })();
        }
    }, [estadosActualizados, formData, estadoCampoReque]);


    const handleChange = (event) => {

        setFormCompletado(null); // Reiniciar el estado de formCompletado al cambiar cualquier campo
    
            const { name, value, type, checked } = event.target;
    
            let newValue;
            if (type == 'checkbox') {
                newValue = checked;
                
                if (name == "subcategoria" && !checked) {
                    setFormData(prevFormData => ({ ...prevFormData, subcategorias: [] }));
                }
            }
    
            else {
                newValue = value;
            }
            setFormData(prevFormData => ({ ...prevFormData, [name]: newValue }));
            setFormData(prevFormData => ({ ...prevFormData, urlCat: prevFormData.categoria.trim().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, "-").toLowerCase()}));
            if (name in estadoCampoReque) {
                handleChangeErrors(name, value, estadoCampoReque, setEstadoCampoReque, setEstadosActualizados);
            }
    
            console.log("formData ", formData);
    
        };

    return (
        <>
            <Form >
                <CabeceraForm>
                    <Titulo
                        texto="EDITAR UNA CATEGORIA"
                        convocatoria="true"
                    />
                </CabeceraForm>

                <Container>
                    <ToastContainer/>
                <Col>
                        <Row md="5">
                            <Col md={3}>

                            </Col>


                            <Col md={3}>
                                <Form.Group>
                                    <TituloCategoria>Nombre <span>*</span></TituloCategoria>
                                    <Form.Control type="name" name="categoria" value={formData.categoria || ''} onChange={handleChange} />
                                    <ErrorForm mensaje={camposRequeridos.categoria} estadoAlerta={estadoCampoReque.categoria} />
                                </Form.Group>
                            </Col>
                            
                            <Col md={3}>
                                <Form.Group>
                                    <TituloCategoria>Descripción </TituloCategoria>
                                    <Form.Control type="text" name="descripcion" value={formData.descripcion || ''} onChange={handleChange} />
                                </Form.Group>
                            </Col>

                        </Row>
                        <Row className="mt-4">
                        </Row>
                        <Row md="5">
                            <Col md={3}>
                            </Col>


                            <Col md={4}>
                                <Form.Group>
                                    <InputLabel>
                                        <TituloCategoria>Subcategorias</TituloCategoria>
                                    </InputLabel>
                                    <Select
                                        disabled={!formData.subcategoria}
                                        multiple
                                        native
                                        value={formData.subcategorias}
                                        onChange={handleChangeMultiple}
                                        inputProps={{
                                            id: 'select-multiple-native',
                                        }}
                                    >
                                        {subcategorias.map((subcategoria) => (
                                            <option key={subcategoria.Id} value={subcategoria.Id}>
                                                {subcategoria.nombre}
                                            </option>
                                        ))}
                                    </Select>
                                </Form.Group>
                            </Col>
                            <Col md={1}>
                                <Row>
                                    <Col>
                                        <Form.Group className="d-flex align-items-center">

                                            <EstiloSwitch
                                                name="subcategoria"
                                                checked={formData.subcategoria || false}
                                                onChange={handleChange}
                                                type="switch"
                                                id="subcategoria"
                                            />
                                            <TituloCategoria style={{ marginTop: "10px", marginLeft: "10px" }}>Subcategoria</TituloCategoria>
                                        </Form.Group>
                                    </Col>




                                    <Col>
                                        <Form.Group className="d-flex align-items-center">
                                            <EstiloSwitch
                                                name="nivel"
                                                checked={formData.nivel || false}
                                                onChange={handleChange}
                                                type="switch"
                                                id="nivel"
                                            />
                                            <TituloCategoria style={{ marginTop: "10px", marginLeft: "10px" }}>Nivel</TituloCategoria>
                                        </Form.Group>
                                    </Col>

                                    <Col>
                                        <Form.Group className="d-flex align-items-center">
                                            <EstiloSwitch
                                                name="anexo"
                                                checked={formData.anexo || false}
                                                onChange={handleChange}
                                                type="switch"
                                                id="anexo"
                                            />
                                            <TituloCategoria style={{ marginTop: "10px", marginLeft: "10px" }}>Anexo</TituloCategoria>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Col>


                        </Row>
                    </Col>

                    <Row >

                        <Col >
                            <ContenedorBotones>

                                <Boton
                                    convocatoria="true"
                                    grande="true"
                                    as="button"
                                    primario="true"
                                    type="submit"
                                    onClick={handleSubmit}
                                    form="true"ç
                                    name='guardar_cambios_statico'
                                >
                                    Guardar
                                </Boton>

                                <Boton
                                    convocatoria="true"
                                    grande="true"
                                    as="button"
                                    primario="true"
                                    type="submit"
                                    onClick={handleSubmit}
                                    form="true"
                                >
                                    Guardar y Salir
                                </Boton>
                                <Boton
                                    grande="true"
                                    to="/convocatoria/categorias"
                                >
                                    Cancelar
                                </Boton>
                            </ContenedorBotones>
                        </Col>
                    </Row>


                </Container>

            </Form>

            {botonRenderClick ? 
                <DatosCorrectos envioActivado={formCompletado} />         
                :             
                <DatosCorrectos envioActivado={formCompletado} redirect={false} />
            }

            <DatosIncorrectos envioActivado={formCompletado} />
            <CategoriaExistente envioActivado={errorEnviarForm.categoriaDuplicada} />
        </>
    );
}



const CabeceraForm = styled.div`
    margin: 5% 0% 2% 35%;
`

const ContenedorBotones = styled.div`
    margin-top: 1%;
        display: flex;
     justify-content: center;
     gap: 10px; 
`

const TituloCategoria = styled(Form.Label)`
    font-weight: bold;
    font-family: 'Open Sans';
    font-size: 15.6px;
    line-height: 1.8;
    color: #4a4a4a;

    span{
        color: #ff0000;
        font-weight: 400;
    }
`

const EstiloSwitch = styled(Form.Check)`
    
    .form-check-input {
        width: 3.5em !important;
        height: 1.8em !important;
        background-size: 1.5em 1.5em;
        background-color: white;
    }

    .form-check-input:checked {
        background-color: rgb(238, 128, 93) !important;
        border: #dee2e6;
        box-shadow: 0 0 0 .25rem rgba(238, 128, 93, .25);
        --bs-form-switch-bg: url('data:image/svg+xml,%3csvg xmlns="http://www.w3.org/2000/svg" viewBox="-4 -4 8 8"%3e%3ccircle r="3" fill="rgba(0, 0, 0, 0.25)" /%3e%3c/svg%3e') !important;
    }

    .form-check-input:focus {
        border-color: #dee2e6 !important;
        box-shadow: none; 
        --bs-form-switch-bg: url('data:image/svg+xml,%3csvg xmlns="http://www.w3.org/2000/svg" viewBox="-4 -4 8 8"%3e%3ccircle r="3" fill="rgba(0, 0, 0, 0.25)" /%3e%3c/svg%3e') !important;
    }
`





export default FormEditarCategoria;